/**
 * seo.js — SEO + Open Graph defaults.
 */
const env = import.meta.env ?? {};

export const SITE_URL = String(env.VITE_SITE_URL ?? 'https://marketwatcher.app').replace(/\/+$/, '');

export const DEFAULT_SEO = {
  title: 'MarketWatcher — AI Trading Terminal',
  description:
    'Multi-timeframe signals, liquidation heatmaps, AI Market Brain, and forecast — one professional trading terminal for crypto and equities.',
  ogImage: '/og-image.png',
  twitterCard: 'summary_large_image',
  siteName: 'MarketWatcher',
};

export const ROUTE_SEO = {
  home: {
    title: 'MarketWatcher — AI Trading Terminal',
    description: DEFAULT_SEO.description,
  },
  features: {
    title: 'Features — MarketWatcher',
    description: 'Charts, signals, AI Market Brain, heatmaps, forecast, and multi-asset pulse in one terminal.',
  },
  pricing: {
    title: 'Pricing — MarketWatcher',
    description: 'Free, Core, Pro, and Terminal plans with clear limits. Upgrade anytime.',
  },
  faq: {
    title: 'FAQ — MarketWatcher',
    description: 'Answers about accounts, plans, data sources, security, and support.',
  },
  legal: {
    title: 'Legal — MarketWatcher',
    description: 'Imprint, privacy policy, and terms of service.',
  },
};
